import { KizViewPluginSettings } from "../../../Dictionaries/Kiz/KizView/KizViewPluginSettings";
import { PaletteBoxCreatePluginSettings } from "../../../Dictionaries/Kiz/ScanModal/box/PaletteBoxCreatePluginSettings";
import { ScanBoxCreatePluginSettings } from "../../../Dictionaries/Kiz/ScanModal/box/ScanBoxCreatePluginSettings";
import { ScanBoxGismtCreatePluginSettings } from "../../../Dictionaries/Kiz/ScanModal/boxGismt/ScanBoxGismtCreatePluginSettings";
import { KizOsuModalViewPluginSettings } from "../../../Dictionaries/Kiz/ScanModal/kizOsu/KizOsuModalViewPluginSettings";

const InvoiceItemGridPluginSettings: IPluginSettings = {
    name: "Позиции",
    mnemocode: "invoice_item_plugin",
    permission: "Invoice",
    columns: [
        {
            order: 0,
            propertyName: "goodsName",
            propertyType: "string",
            displayName: "Наименование товара",
            visibility: true,
            width: 204,
        },
        {
            order: 1,
            propertyName: "quantity",
            propertyType: "number",
            displayName: "Кол-во",
            visibility: true,
            width: 99,
        },
        {
            order: 2,
            propertyName: "actualQuantity",
            propertyType: "number",
            displayName: "Количество факт.",
            visibility: true,
            width: 109,
        },
        {
            order: 3,
            propertyName: "retailAdprice",
            propertyType: "number",
            displayName: "Наценка, розн.",
            visibility: true,
            width: 100,
        },
        {
            order: 4,
            propertyName: "retailPrice",
            propertyType: "number",
            displayName: "Цена, розн.",
            visibility: true,
            width: 109,
        },
        {
            order: 5,
            propertyName: "retailVat",
            propertyType: "number",
            displayName: "НДС, розн.",
            visibility: true,
            width: 99,
        },
        {
            order: 6,
            propertyName: "retailPriceIncVat",
            propertyType: "number",
            displayName: "Цена с НДС, розн.",
            visibility: true,
            width: 99,
        },
        {
            order: 7,
            propertyName: "retailSum",
            propertyType: "number",
            displayName: "Сумма б/НДС, розн.",
            visibility: true,
            width: 99,
        },
        {
            order: 8,
            propertyName: "retailVatSum",
            propertyType: "number",
            displayName: "Сумма НДС, розн.",
            visibility: true,
            width: 99,
        },
        {
            order: 9,
            propertyName: "retailSumIncVat",
            propertyType: "number",
            displayName: "Сумма с НДС, розн.",
            visibility: true,
            width: 99,
        },
        {
            order: 10,
            propertyName: "bestBefore",
            propertyType: "date",
            displayName: "Срок годности",
            visibility: true,
            width: 126,
        },
        {
            order: 11,
            propertyName: "seriesNumber",
            propertyType: "string",
            displayName: "Серия",
            visibility: true,
            width: 99,
        },
        {
            order: 12,
            propertyName: "gtin",
            propertyType: "string",
            displayName: "Gtin",
            visibility: true,
            width: 99,
        },
        {
            order: 13,
            propertyName: "producer",
            propertyType: "string",
            displayName: "Производитель",
            visibility: true,
            width: 199,
        },
        {
            order: 14,
            propertyName: "hasDefects",
            propertyType: "boolean",
            displayName: "Признак бракованной партии",
            visibility: true,
            width: 149,
        },
        {
            order: 15,
            propertyName: "damageQuantity",
            propertyType: "number",
            displayName: "Бой",
            visibility: true,
            width: 99,
        },
        {
            order: 16,
            propertyName: "defectQuantity",
            propertyType: "number",
            displayName: "Брак",
            visibility: true,
            width: 106,
        },
        {
            order: 17,
            propertyName: "shortageQuantity",
            propertyType: "number",
            displayName: "Недостача",
            visibility: true,
            width: 99,
        },
        {
            order: 18,
            propertyName: "isGnvls",
            propertyType: "boolean",
            displayName: "ЖНВЛП",
            visibility: true,
            width: 99,
        },
        {
            order: 19,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "ИД",
            visibility: false,
            width: 200,
        },
        {
            order: 20,
            propertyName: "scalingRatioName",
            propertyType: "string",
            displayName: "Ед. изм.",
            visibility: false,
            width: 200,
        },
        {
            order: 21,
            propertyName: "supplierAdprice",
            propertyType: "number",
            displayName: "Наценка, пост.",
            visibility: false,
            width: 164,
        },
        {
            order: 22,
            propertyName: "supplierPrice",
            propertyType: "number",
            displayName: "Цена б/НДС, пост.",
            visibility: false,
            width: 100,
        },
        {
            order: 23,
            propertyName: "supplierVatPrice",
            propertyType: "number",
            displayName: "Значение НДС, пост.",
            visibility: false,
            width: 150,
        },
        {
            order: 24,
            propertyName: "supplierVat",
            propertyType: "number",
            displayName: "Ставка НДС, пост.",
            visibility: false,
            width: 100,
        },
        {
            order: 25,
            propertyName: "supplierPriceIncVat",
            propertyType: "number",
            displayName: "Цена с НДС, пост.",
            visibility: false,
            width: 100,
        },
        {
            order: 26,
            propertyName: "supplierSum",
            propertyType: "number",
            displayName: "Сумма б/НДС, пост.",
            visibility: false,
            width: 100,
        },
        {
            order: 27,
            propertyName: "supplierVatSum",
            propertyType: "number",
            displayName: "Сумма НДС, пост.",
            visibility: false,
            width: 100,
        },
        {
            order: 28,
            propertyName: "supplierSumIncVat",
            propertyType: "number",
            displayName: "Сумма с НДС, пост.",
            visibility: false,
            width: 100,
        },
        {
            order: 29,
            propertyName: "retailVatPrice",
            propertyType: "number",
            displayName: "Значение НДС, розн.",
            visibility: false,
            width: 142,
        },
        {
            order: 30,
            propertyName: "isKiz",
            propertyType: "boolean",
            displayName: "Ввод КИЗ",
            visibility: false,
            width: 100,
        },
        {
            order: 31,
            propertyName: "idInvoiceItemGroupGlobal",
            propertyType: "string",
            displayName: "Группа пересорта",
            visibility: false,
            width: 200,
        },
        {
            order: 32,
            propertyName: "isOsu",
            propertyType: "boolean",
            displayName: "Признак воды",
            visibility: false,
            width: 200,
        },
        {
            order: 33,
            propertyName: "isKizDocReady",
            propertyType: "boolean",
            displayName: "Идентификатор документа МДЛП",
            visibility: false,
            width: 200,
        },
        {
            order: 34,
            propertyName: "goodsCode",
            propertyType: "string",
            displayName: "Код товара",
            visibility: false,
            width: 200,
        },
        {
            order: 35,
            propertyName: "gosContractName",
            propertyType: "string",
            displayName: "ГК",
            visibility: false,
            width: 200,
        },
        {
            order: 36,
            propertyName: "storePlaceName",
            propertyType: "string",
            displayName: "Место хранения",
            visibility: false,
            width: 200,
        },
        {
            order: 38,
            propertyName: "financialSecurityCode",
            propertyType: "string",
            displayName: "Код финансового обеспечения",
            visibility: false,
            width: 200,
        },
    ],
    detailsPlugins: [KizViewPluginSettings, ScanBoxCreatePluginSettings, PaletteBoxCreatePluginSettings, KizOsuModalViewPluginSettings, ScanBoxGismtCreatePluginSettings],
};

export default InvoiceItemGridPluginSettings;